// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Models
import { IConversationSuggestion } from '@/models/suggestedFaq.model';

// Components
import { StyledCard, StyledCardHeader, StyledCardTitle } from '../Styled';
import { StyledCountBadge, StyledScrollableCardBody } from './ConversationSuggestedFaqCardStyles';
import ConversationSuggestedFaqItem from '../ConversationSuggestedFaqItem/ConversationSuggestedFaqItem';

type TConversationSuggestedFaqCardProps = {
  suggestions: IConversationSuggestion[];
};

const ConversationSuggestedFaqCard: FC<TConversationSuggestedFaqCardProps> = ({ suggestions }) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>{t('menu_suggested_faq')}</StyledCardTitle>
        {!!suggestions.length && <StyledCountBadge>{suggestions.length}</StyledCountBadge>}
      </StyledCardHeader>
      <StyledScrollableCardBody>
        {suggestions.map((suggestion, index) => (
          <ConversationSuggestedFaqItem key={suggestion.reviewId} index={index + 1} suggestion={suggestion} />
        ))}
      </StyledScrollableCardBody>
    </StyledCard>
  );
};

export default ConversationSuggestedFaqCard;
